export enum RestApiEndpoints {
    login = 'login.php',
    burials = 'burials.php',
    addContract = 'add_contract.php',
    addDocument = 'add_document.php',
    deleteContract = 'delete_contract.php',
    downloads = 'downloads.php',
    import = 'import.php',
    loadHistory = 'load_history.php',
    pdfCreate = 'pdf_create.php',
    loadUser = 'load_user.php',
    addUser = 'add_user.php',
    archive = 'archive.php',
    archiveAll = 'archive_all.php',
    loadDocument = 'load_document.php',
    pickupPdfCreate = 'pickup_pdf_create.php',
    passwortsicherheit = 'passwortsicherheit.php',
    contact = 'contact.php',
    searchDocs = 'search_docs.php',
    pushSubscription = 'push_subscription.php',
    calendar = 'kalender.php'
}